module.exports = __webpack_public_path__ + "img/banner-princiapal.cfd96f64.svg";